import { apiClient, type SignedUrlForUploadEntity } from '@/libs/api'

export const getUploadSignedUrl =
  async (): Promise<SignedUrlForUploadEntity> => {
    const { data } = await apiClient.uploads.get_signed_url.$get()
    return data
  }
